<template>
  <router-link
    v-if="tenderId"
    :to="`/tender/${tenderId}`"
    :class="`${baseClass} pa-6`"
    class="saved-search-award-card-link"
    target="_blank"
  >
    <div :class="`${baseClass}-main-row`">
      <div :class="`${baseClass}-content flex-grow-1`">
        <div :class="`${baseClass}-title-row`">
          <span :class="`${baseClass}-title`">
            {{ row.title || 'Contract' }}
          </span>
        </div>

        <saved-search-meta-chips
          :row="row"
          @filter-notice-type="$emit('filter-notice-type', $event)"
        />
      </div>
    </div>

    <div :class="`${baseClass}-details-container mb-4`">
      <v-row :class="`${baseClass}-details-row`">
        <v-col cols="6" :class="`${baseClass}-detail-col`">
          <div :class="`${baseClass}-detail-label text-body mb-1`">Buyer</div>
          <div :class="`${baseClass}-detail-value text-body-2 font-weight-medium`">
            <router-link
              v-if="row.publisher_id"
              :to="`/entity/${row.publisher_id}`"
              :class="`${baseClass}-detail-link text-decoration-none`"
              target="_blank"
              @click.stop
            >
              {{ publisherName }}
            </router-link>
            <span v-else>{{ publisherName }}</span>
          </div>
        </v-col>

        <v-col cols="6" :class="`${baseClass}-detail-col`">
          <div :class="`${baseClass}-detail-label text-body mb-1`">Current Holder</div>
          <div :class="`${baseClass}-detail-value text-body-2 font-weight-medium`">
            <router-link
              v-if="row.supplier_id"
              :to="`/supplier/${row.supplier_id}`"
              :class="`${baseClass}-detail-link text-decoration-none`"
              target="_blank"
              @click.stop
            >
              {{ supplierName }}
            </router-link>
            <span v-else>{{ supplierName }}</span>
          </div>
        </v-col>

        <v-col cols="6" :class="`${baseClass}-detail-col`">
          <div :class="`${baseClass}-detail-label text-body mb-1`">Contract Value</div>
          <div :class="`${baseClass}-detail-value text-body-2 font-weight-medium`">
            {{ formatCurrency(row.value || 0) }}
          </div>
        </v-col>

        <v-col cols="6" :class="`${baseClass}-detail-col`">
          <div :class="`${baseClass}-detail-label text-body mb-1`">Starts</div>
          <div :class="`${baseClass}-detail-value text-body-2 font-weight-medium`">
            {{ startsDisplay }}
          </div>
        </v-col>

        <v-col cols="6" :class="`${baseClass}-detail-col`">
          <div :class="`${baseClass}-detail-label text-body mb-1`">Expires</div>
          <div :class="`${baseClass}-detail-value text-body-2 font-weight-medium`">
            {{ expiresDisplay }}
          </div>
        </v-col>
      </v-row>
    </div>

    <div
      v-if="$slots.actions"
      :class="`${baseClass}-actions d-flex justify-end`"
      @click.stop.prevent
    >
      <slot name="actions" :row="row" />
    </div>
  </router-link>
</template>

<script>
import SavedSearchMetaChips from './SavedSearchMetaChips.vue';
import { formattedCurrency, formatDateReadable } from '../Utils.js';

export default {
  name: 'SavedSearchAwardCard',

  components: {
    SavedSearchMetaChips,
  },

  props: {
    row: {
      type: Object,
      required: true,
    },
    baseClass: {
      type: String,
      default: 'saved-search-award-card',
    },
  },

  computed: {
    tenderId() {
      return this.row?.tender_id || this.row?.id || null;
    },

    publisherName() {
      return this.row?.publisher_name || this.row?.publisher || '—';
    },

    supplierName() {
      return this.row?.supplier_name || this.row?.supplier || '—';
    },

    startsDate() {
      return this.row?.contract_start || this.row?.display_date || null;
    },

    startsDisplay() {
      return this.startsDate ? formatDateReadable(this.startsDate) : '—';
    },

    expiresDisplay() {
      return this.row?.contract_end
        ? formatDateReadable(this.row.contract_end)
        : '—';
    },
  },

  methods: {
    formatCurrency(value) {
      return formattedCurrency(value);
    },
  },
};
</script>

<style scoped>
.saved-search-award-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  background-color: #f9fafb;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.saved-search-award-card-link:hover {
  background-color: #f3f4f6;
}

.saved-search-award-card-title-row {
  margin-bottom: 4px;
}

.saved-search-award-card-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #1f2937;
}

.saved-search-award-card-details-container {
  margin-top: 12px;
}

.saved-search-award-card-detail-link {
  color: inherit;
}

.saved-search-award-card-actions {
  margin-top: 12px;
  gap: 12px;
}

/* Five equal columns on one row */
@media (min-width: 960px) {
  .saved-search-award-card-details-row {
    flex-wrap: nowrap;
  }

  .saved-search-award-card-details-row > .saved-search-award-card-detail-col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
